import React from 'react';
import Select from 'react-select';
import FileListForm from './FileListForm';
import LinkListForm from './LinkListForm';
import { sortOpts } from '../../utils/utils';

export default class FilesAndLinksForm extends React.Component {

  state = {
    filetypeId: 0
  }

  updateFiletype = e => {
    this.setState({filetypeId: e ? e.value : 0});
  }

  render () {
    const { filetypeId } = this.state;
    const { order, files, filetypes, editFile, links, editLink } = this.props;

    const filetypesOpt = [];
    for (let key in filetypes){
      if (filetypes.hasOwnProperty(key) && filetypes[key].filetype_active) {
        filetypesOpt.push({
          value: filetypes[key].filetype_id,
          label: filetypes[key].filetype_desc
        });
      }
    }
    filetypesOpt.sort(sortOpts);

    return(
      <div>
        <div className="form-group form-inline margins">
          <span>Тип файлов </span>
          <div className="input-group" style={{zIndex: 2}}>
            <Select
              style={{width:'230px'}}
              options={filetypesOpt}
              value={filetypeId}
              onChange={this.updateFiletype}
              placeholder="Тип файлов"
            />
          </div>
        </div>
        <FileListForm
          order={order}
          files={files}
          filetypes={filetypes}
          editFile={editFile}
          filetypeId={filetypeId}
        />
        <h3>Ссылки</h3>
        <LinkListForm
          order={order}
          links={links}
          filetypes={filetypes}
          editLink={editLink}
          filetypeId={filetypeId}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/order/FilesAndLinksForm.js